import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { hideError } from "../../store/errorSlice";
import { FailurePopup } from "./FailurePopup";

const ErrorHandler = () => {
  const { message, isVisible } = useSelector((state: RootState) => state.error);
  const dispatch = useDispatch();

  return (
    <FailurePopup
      message={message || ""}
      isOpen={isVisible}
      onClose={() => dispatch(hideError())}
    />
  );
};

export default ErrorHandler;
